export enum SuccessMessage {
  SaveTimesheet = 'Timesheet has been saved',
  SubmitTimeshet = 'Timesheet has been submitted',
  ChangeEligibility = 'Eligibility settings have been saved',
  ChangeAccess = 'Access level has been updated',
  RecallTimesheet = 'Timesheet has been recalled',
  ChangeLayout = 'Report settings have been saved',
  ReopenTimesheet = 'Timesheet has been reopened',
  ChangeCustomDeadline = 'Custom Deadline settings have been saved',
  ChangeDefaultDeadline = 'New Default Deadline is applied from',
  ChangeDefaultNotifications = 'New Default Notification settings are applied from',
  ChangeCustomNotifications = 'Custom Notification settings have been saved'
}

export enum ErrorMessage {
  General = 'Action failed due to an error',
  GetEmployeesData = 'Employee data is not available due to an error',
  GetUserData = 'User data is not available due to an error',
  GetTimesheetData = 'Timesheet data is not available due to an error',
  GetReportData = 'Report data is not available due to an error',
  GetReportsArchiveData = 'Reports Archive data is not available due to an error',
  GetEligibilityData = 'Employee data is not available due to an error',
  GetLayoutSettingsData = 'Report layout settings are not available due to an error',
  GetDefaultDeadlineData = 'Default Deadline data is not available due to an error',
  GetDeadlineForSelectedMonth = 'Deadline data is not available due to an error',
  GetLinks = 'Support menu links are not available due to an error',
  Config = 'Config is not available due to an error',
  GetDefaultNotificationsData = 'Default Notification settings are not available due to an error',
  GetCustomNotificationsData = 'Notification settings are not available due to an error',
  PostCustomNotificationsData = 'Past Date/Time cannot be set for a Custom Notification',
  GetRestoredDefaultDeadlineData = 'Past Default Deadline date/time cannot be set as a Custom Deadline',
  PostCustomDeadlineData = 'Past Date/Time cannot be set as a Custom Deadline'
}
